module.exports = __webpack_public_path__ + "img/avatar.4ef0b94a.jpg";